/**
 * fragments.js — Shared GraphQL fragment for Shopify Cart data.
 *
 * CheckoutFragment is imported by cart mutation files to avoid
 * duplicating the full cart field selection.
 */
import gql from "graphql-tag";

export const CheckoutFragment = gql`
  fragment CheckoutFragment on Cart {
    id
    checkoutUrl
    cost {
      subtotalAmount {
        amount
        currencyCode
      }
      totalAmount {
        amount
        currencyCode
      }
    }
    lines(first: 50) {
      edges {
        node {
          id
          quantity
          merchandise {
             ... on ProductVariant {
              id
              product{
                id
                title
                handle
                metafields(identifiers: [{namespace: "arena", key: "all_data"}]) {
                  key
                  value
                  namespace
                }
              }
              price{
                amount
                currencyCode
              }
            }
          }      
        }
      }
    }
  }
`;
